var _style, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachineLearningGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A1A1A1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385,85c0,11.1-6,20.8-15,26v64H250v-30h90v-34c-9-5.2-15-14.9-15-26c0-16.6,13.4-30,30-30S385,68.4,385,85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460,220c0,16.6-13.4,30-30,30c-11.1,0-20.8-6-26-15H250v-30h154c5.2-9,14.9-15,26-15 C446.6,190,460,203.4,460,220z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355,415c0,16.6-13.4,30-30,30s-30-13.4-30-30c0-11.1,6-20.8,15-26v-34h-60v-30h90v64 C349,394.2,355,403.9,355,415z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425,355c0,16.6-13.4,30-30,30s-30-13.4-30-30c0-11.1,6-20.8,15-26v-34H250v-30h160v64 C419,334.2,425,343.9,425,355z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235,50.2C224.9,43.8,212.9,40,200,40c-31.8,0-58.3,22.9-63.9,53.1C98.3,101.7,70,135.6,70,176 c0,6.2,0.7,12.2,1.9,18C52.8,205.4,40,226.2,40,250c0,23.8,12.8,44.6,31.9,56c-1.3,5.8-1.9,11.9-1.9,18c0,40.4,28.3,74.3,66.1,82.9 c5.6,30.2,32.1,53.1,63.9,53.1c12.9,0,24.9-3.8,35-10.2c18-11.6,30-31.8,30-54.8V105C265,82,253,61.8,235,50.2z M235,394.3 c0,19.3-15.3,35.4-34.6,35.7c-14.9,0.2-27.6-9-32.9-21.9c-1.6-4-2.5-8.5-2.5-13.1c0-6.6,1.8-12.8,5-18.1c2.6-4.3,2-9.9-1.6-13.5 c-8.4-8.4-22.8-6-27.7,4.9c-1.1,2.6-2.1,5.2-2.9,7.9C115.8,369,100,348.3,100,324c0-3.1,0.3-6.2,0.8-9.1c1.3-8,4.4-15.4,8.8-21.8 c2.4-3.5-0.1-8.1-4.3-8.1H105c-8,0-15.4-2.7-21.3-7.2C75.4,271.4,70,261.3,70,250s5.4-21.4,13.7-27.8c5.9-4.5,13.3-7.2,21.3-7.2h0.3 c4.2,0,6.7-4.6,4.3-8.1c-4.4-6.4-7.5-13.8-8.8-21.8c-0.5-3-0.8-6-0.8-9.1c0-24.3,15.8-45,37.8-52.2c0.8,2.7,1.8,5.3,2.9,7.9 c4.9,10.9,19.3,13.4,27.7,4.9c2.1-2.1,3.2-4.9,3.2-7.8c0-2-0.5-3.9-1.6-5.7c-3.2-5.3-5-11.5-5-18.1c0-4.6,0.9-9,2.5-13.1 c5.3-13,18-22.1,32.9-21.9c19.3,0.2,34.6,16.4,34.6,35.7v54v180.5V394.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineLearningGray);
export default __webpack_public_path__ + "static/media/Machine-Learning-Gray.e9090dacf7da112a70c709d84f5aa900.svg";
export { ForwardRef as ReactComponent };